import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { clsx } from 'clsx';
import { Toast } from '../Toast';
import { useDeviceType } from '../../../responsive/hooks';
import { useUiKitToastApiContext } from '../../context';
import * as styles from './ToastContainer.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
var ToastContainerComponent = function ToastContainerComponent(props) {
  var placement = props.placement,
    stackApi = props.stackApi;
  var _useUiKitToastApiCont = useUiKitToastApiContext(),
    indentByPlacement = _useUiKitToastApiCont.indentByPlacement;
  var _stackApi = _slicedToArray(stackApi, 2),
    toastsStack = _stackApi[0],
    setToastsStack = _stackApi[1];
  var intervalId = React.useRef();
  var holderRef = React.useRef(null);
  var deviceType = useDeviceType();
  var isMobile = deviceType === 'phone';

  /**
   * Это механизм очищения DOM от уже исчезнувших тостов.
   * Нет смысла держать элементы в DOM, если они уже скрыты.
   */
  React.useEffect(function () {
    if (!toastsStack.length) {
      return;
    }
    clearInterval(intervalId.current);
    intervalId.current = window.setInterval(function () {
      var isEveryHidden = toastsStack.every(function (toast) {
        return toast.hidden;
      });
      if (isEveryHidden) {
        setToastsStack([]);
        clearInterval(intervalId.current);
      }
    }, 500);
    return function () {
      return clearInterval(intervalId.current);
    };
  }, [toastsStack, setToastsStack]);

  /**
   * Это способ установки пользовательского отступа для контейнера тостов в зависимости от его расположения.
   */
  React.useEffect(function () {
    var containerIndent = indentByPlacement[placement];
    if (holderRef.current && containerIndent) {
      if (isMobile) {
        holderRef.current.style.marginBottom = containerIndent;
        return;
      }
      switch (placement) {
        case 'top-center':
        case 'top-right':
          holderRef.current.style.marginTop = containerIndent;
          break;
        case 'bottom-center':
        case 'bottom-right':
          holderRef.current.style.marginBottom = containerIndent;
          break;
        default:
          break;
      }
    }
  }, [placement, indentByPlacement, isMobile]);
  var toasts = React.useMemo(function () {
    return toastsStack.map(function (toastData) {
      return /*#__PURE__*/_jsx(Toast, _objectSpread({
        autoHide: toastData.autoHide === undefined || toastData.autoHide,
        hasCloseIcon: toastData.hasCloseIcon === undefined || toastData.hasCloseIcon
      }, toastData), toastData.id);
    });
  }, [toastsStack]);
  if (typeof window === 'undefined' || !toastsStack.length) {
    return null;
  }
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/_jsx("div", {
    className: clsx(styles['container'], styles[placement], "ui-kit-toast-container__".concat(placement)),
    children: /*#__PURE__*/_jsx("section", {
      className: clsx(styles['holder'], styles[placement], isMobile && styles['mobile']),
      ref: holderRef,
      children: toasts
    })
  }), document.body);
};
export var ToastContainer = /*#__PURE__*/React.memo(ToastContainerComponent);